<textarea
  matInput
  [required]="to.required"
  [attr.readonly]="to.readonly ? '' : null"
  [placeholder]="to.placeholder"
  [attr.maxlength]="to.maxlength"
  [attr.rows]="to.rows"
  [style.height]="to.height"
  [readonly]="to.readonly"
  (change)="onChange($event)"
  [formControl]="formControl"
  #textareaEl
></textarea>

<ng-content></ng-content>
